import { css } from '@emotion/react';
// Constants
import { Color } from "../../constants/Colors";
import { Group } from "./constants";

export const useStyles = (props) => ({
    root: css({
        width: 'fit-content',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        "&:hover": {
            transition: '0.15s all linear',
            "& $tourRibbon": {
                backgroundColor: props.group === Group.STOPPT
                    ? Color.neutral[400]
                    : (props.group === Group.UNTERWEGS
                        ? Color.primary[400]
                        : Color.success[400])
            },
            "& $showMore": {
                display: "block"
            },
            "& $capacityCard,& $tourCard": {
                backgroundColor: Color.neutral[100]
            }
        }
    }),
    tourCard: css({
        borderTop: `1px solid ${Color.neutral[100]}`,
        borderBottom: `1px solid ${Color.neutral[100]}`,
        position: 'relative',
        boxSizing: 'border-box',
        padding: 14,
        width: 530,
        height: 128,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: Color.neutral[0],
        cursor: 'pointer',
        transition: '0.15s all linear',
    }),
    capacityCard: css({
        borderTop: `1px solid ${Color.neutral[100]}`,
        borderBottom: `1px solid ${Color.neutral[100]}`,
        borderRight: `1px solid ${Color.neutral[100]}`,
        position: 'absolute',
        right: -150,
        boxSizing: 'border-box',
        padding: 14,
        width: 150,
        height: 128,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: Color.neutral[0],
        transition: '0.15s all linear',
    }),
    detailCard: css({
        boxSizing: 'border-box',
        padding: 20,
        width: 753,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: Color.neutral[0],
    }),
    detailContent: css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 10,
        marginTop: 10
    }),
    detailProgessTextContainer: css({
        position: 'absolute',
        left: 87,
        top: 80,
        "& p": {
            lineHeight: 1.2
        }
    }),
    detailProgress: css({
        width: '60%',
        height: 200,
        overflowY: 'auto'
    }),
    detailTripProgress: css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        padding: '10px 5px'
    }),
    progressBarContainer: css({
        marginTop: 14,
        height: 15,
        width: 122,
        backgroundColor: Color.neutral[200],
        borderRadius: 50,
    }),
    progressBarFill: css({
        height: '100%',
        width: `${props.data.currentLoad / props.data.capacity * 100}%`,
        backgroundImage: `linear-gradient(to right, ${Color.primary[700]} , ${Color.primary[400]})`,
        borderRadius: 'inherit',
    }),
    tourRibbon: css({
        position: 'absolute',
        width: 16,
        height: 101,
        left: 0,
        transition: '0.15s all linear',
        backgroundColor: props.group === Group.STOPPT
            ? Color.neutral[200]
            : (props.group === Group.UNTERWEGS
                ? Color.primary[200]
                : Color.success[200])
    }),
    capacityRibbon: css({
        position: 'absolute',
        width: 2,
        height: 58,
        left: 0,
        backgroundColor: Color.neutral[200]
    }),
    diagramContainer: css({
        paddingLeft: 16,
        height: 101,
        width: 101
    }),
    progressContainer: css({
        height: 81,
        width: 101
    }),
    progressChart: css({
        display: 'block',
        margin: 'auto'
    }),
    progessTextContainer: css({
        textAlign: 'center',
        marginTop: -59,
        "& p": {
            lineHeight: 1.2
        }
    }),
    valueContainer: css({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 20
    }),
    value: css({
        color: Color.primary[500],
        fontSize: 20
    }),
    valueDisabled: css({
        color: Color.neutral[400],
        fontSize: 20
    }),
    navigation: css({
        color: Color.primary[400],
        fontSize: 20,
        marginRight: 5,
        marginLeft: -3
    }),
    close: css({
        color: Color.danger[400],
        fontSize: 20,
        marginRight: 3,
        marginLeft: -3
    }),
    standby: css({
        color: Color.primary[400],
        fontSize: 20,
        marginRight: 5,
        marginLeft: -2
    }),
    pause: css({
        color: Color.neutral[400],
        fontSize: 20,
        marginRight: 5,
        marginLeft: -3
    }),
    rightArrow: css({
        color: Color.primary[200],
        fontSize: 20,
        marginLeft: 7
    }),
    arrowHeadRight: css({
        color: Color.neutral[900],
        fontSize: 24,
        marginLeft: 7,
        marginRight: 7
    }),
    checkmark: css({
        color: Color.primary[400],
        fontSize: 24,
        marginLeft: 30
    }),
    arrival: css({
        color: Color.success[300],
        fontSize: 24,
        marginLeft: 30
    }),
    location: css({
        color: Color.primary[200],
        fontSize: 20,
        marginLeft: 5
    }),
    badge: css({
        marginLeft: 12,
        backgroundColor: Color.primary[200],
        borderRadius: 25,
        padding: '2px 8px 2px 8px'
    }),
    deliveredCircle: css({
        borderRadius: 50,
        width: 20,
        height: 20,
        backgroundColor: Color.primary[600],
        marginRight: 10
    }),
    ongoingCircle: css({
        borderRadius: 50,
        width: 20,
        height: 20,
        backgroundColor: Color.primary[300],
        marginRight: 10
    }),
    queuedCircle: css({
        borderRadius: 50,
        width: 20,
        height: 20,
        backgroundColor: Color.neutral[300],
        marginRight: 10
    }),
    informationContainer: css({
        paddingLeft: 16,
        height: 101,
        width: 350
    }),
    lastUpdate: css({
        float: 'right',
        marginTop: 10
    }),
    showMore: css({
        position: "absolute",
        top: 12,
        right: 14,
        display: "none",
        color: Color.primary[500],
        fontSize: 24,
        cursor: 'pointer',
        transition: '0.15s all linear'
    }),
    closeIcon: css({
        color: Color.primary[500],
        fontSize: 24,
        cursor: 'pointer'
    }),
    warningIndicator: css({
        display: props.data.lastUpdate >= props.data.warningThreshold
            ? 'block'
            : 'none',
        height: 14,
        width: 14,
        backgroundColor: Color.danger[400],
        marginRight: 2
    }),
    flexStart: css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start'
    }),
    flexSpaceBetween: css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    })
});
